// extracted by mini-css-extract-plugin
export default {"range":"styled-slider_range__EdHBS","sliderBg":"styled-slider_sliderBg__dhVIl"};